// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"506da295","684":"193b9525","693":"e52e55ab"}[chunkId] + ".chunk.js";
};